module.exports = __webpack_public_path__ + "static/media/File Icon.ecaccc82.png";